export const SEND_PASSWORD_RESET_EMAIL_REQUEST = 'SEND_PASSWORD_RESET_EMAIL_REQUEST';
export const SEND_PASSWORD_RESET_EMAIL_REQUEST_SUCCESS =
  'SEND_PASSWORD_RESET_EMAIL_REQUEST_SUCCESS';
export const SEND_PASSWORD_RESET_EMAIL_REQUEST_ERROR = 'SEND_PASSWORD_RESET_EMAIL_REQUEST_ERROR';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_REQUEST_SUCCESS = 'RESET_PASSWORD_REQUEST_SUCCESS';
export const RESET_PASSWORD_REQUEST_ERROR = 'RESET_PASSWORD_REQUEST_ERROR';
